import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Check } from 'lucide-react';
import { Button } from './ui/Button';
interface FinalOfferSectionProps {
  onCheckout: () => void;
}
export function FinalOfferSection({
  onCheckout
}: FinalOfferSectionProps) {
  return <section className="py-14 bg-black text-white relative overflow-hidden" data-id="element-105">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(184,68,58,0.15)_0%,transparent_70%)] pointer-events-none" data-id="element-106" />

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-107">
        <div className="text-center mb-8" data-id="element-108">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-2xl md:text-4xl font-serif font-bold mb-4 leading-tight" data-id="element-109">
            Dentro de 6 meses vas a estar en el mismo lugar…{' '}
            <br className="hidden md:block" data-id="element-110" />
            <span className="text-terracotta italic" data-id="element-111">
              o habrás cambiado todo.
            </span>
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-base md:text-lg text-gray-400 max-w-2xl mx-auto" data-id="element-112">
            La diferencia entre las dos versiones de vos es una decisión. Este
            Pack puede ser esa decisión.
          </motion.p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} className="bg-white rounded-3xl p-6 md:p-8 text-center shadow-2xl max-w-2xl mx-auto relative" data-id="element-113">
          <div className="absolute -top-5 left-1/2 -translate-x-1/2 bg-gold text-white text-sm font-bold uppercase tracking-widest py-2 px-6 rounded-full shadow-lg" data-id="element-114">
            OFERTA FINAL
          </div>

          <p className="text-gray-500 font-medium mb-3 text-sm" data-id="element-115">
            Si lo compraras por separado pagarías mucho más.
          </p>

          <div className="flex items-baseline justify-center gap-2 md:gap-3 mb-6 tabular-nums" data-id="element-116">
            <span className="text-base md:text-lg text-gray-400 line-through font-medium tracking-tight" data-id="element-117">
              $50.000
            </span>
            <span className="text-4xl md:text-5xl font-bold text-black tracking-tight" data-id="element-118">
              $17.990
            </span>
            <span className="text-xs md:text-sm text-gray-500 font-medium" data-id="element-119">
              ARS
            </span>
          </div>

          <div className="space-y-2 mb-8 text-left max-w-sm mx-auto" data-id="element-120">
            {['+70 recursos digitales', '+55 disciplinas', '3 bonos gratis', 'Acceso inmediato', 'Pagás una vez y es tuyo para siempre'].map((bullet, i) => <div key={i} className="flex items-center gap-3 text-gray-800 font-medium text-sm" data-id="element-121">
                <div className="w-5 h-5 rounded-full bg-green-100 flex items-center justify-center flex-shrink-0" data-id="element-122">
                  <Check className="w-3 h-3 text-green-600" data-id="element-123" />
                </div>
                {bullet}
              </div>)}
          </div>

          <Button onClick={onCheckout} fullWidth className="md:text-lg py-4 mb-3" data-id="element-124">
            SÍ, QUIERO CAMBIAR MI VIDA — $17.990
          </Button>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-4 text-xs md:text-sm text-gray-500 font-medium" data-id="element-125">
            <div className="flex items-center gap-1" data-id="element-126">
              <ShieldCheck className="w-4 h-4 text-green-600" data-id="element-127" /> Compra segura
            </div>
            <span className="hidden sm:block" data-id="element-128">•</span>
            <div data-id="element-129">Descarga inmediata garantizada</div>
            <span className="hidden sm:block" data-id="element-130">•</span>
            <div data-id="element-131">Producto 100% digital</div>
          </div>
        </motion.div>
      </div>
    </section>;
}